<template>
  <label :data-state="state" style="background-color: transparent;" :class="{ outlined }"
         ref="query" for="searchBar">
    <input
        type="text"
        :placeholder="$t('search')"
        v-model="model"
        id="searchBar"
        ref="searchBar"
    />
    <div class="icons">
      <v-icon
          class="px-1 csm-icon csm-icon--magnify"
          :class="{active: state === 'close'}"
          @click="open"
      >
        mdi-magnify
      </v-icon>
      <v-icon
          :class="{active: state === 'open'}"
          class="px-1 csm-icon csm-icon--close"
          @click="close"
      >
        mdi-close
      </v-icon>
    </div>
  </label>

</template>

<script>

export default {
  name: 'TcnQuery',
  emits: ['query'],
  props: {
    defaultValue: {
      type: String,
      default: null,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      state: 'close',
      query: '',
    };
  },
  methods: {
    open() {
      this.state = 'open';
      this.$refs.searchBar.focus();
    },
    close() {
      this.model = '';
      this.state = 'close';
    },
    setTheme() {
      if (this.isDark) {
        this.$refs.query.classList.add('dark-mode');
      } else {
        this.$refs.query.classList.remove('dark-mode');
      }
    },
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.query = val;
        this.$emit('input',val)
      }
    }
  },
  watch: {
    query() {
      if (!this.query || this.query.length >= 3) {
        //deprecated
        this.$emit('query', this.query);
      }
    },
    isDark() {
      this.setTheme();
    },
  },
  i18n: {
    messages: {
      en: {
        "search": "Search",
      },
      pl: {
        "search": "Wyszukaj",
      }
    },
  },
  mounted() {
    if (this.defaultValue != null) {
      this.query = this.defaultValue;
      this.state = 'open';
    }
    this.setTheme();
  },
};
</script>

<style lang="scss" scoped>

.outlined {
  border-radius: 4px;
  border: rgba(0, 0, 0, 0.12) 1px solid;
}

.outlined.dark-mode {
  border: rgba(255, 255, 255, 0.12) 1px solid;
}

.outlined.hi-contrast .dark-mode {
  border: #ffff00 1px solid;
}

.dark-mode input {
  color: white;
}

.hi-contrast *::placeholder {
  color: #ffff00;
}

label {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  transition: all 0.5s ease;
  height: 28px;
  backface-visibility: hidden;

  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    content: '';
    display: block;
    height: 2px;
    width: 100%;
    background-color: var(--v-primary-base);
    transition: all .3s ease-out;
  }

  input {
    transition: width .4s ease-out, opacity .5s ease;
    opacity: 1;
    padding-left: 3px;
    width: 180px;
    height: 100%;
    border: 0;
    outline: none;

  }

  &[data-state="close"] {
    transition: all 0.4s ease;

    &::after {
      width: 0%;
      transition: all 0.4s ease;
    }

    i {
      pointer-events: none;
    }

    input {
      width: 0;
      padding: 0 0;
      height: 100%;
      opacity: 0;
      transition: opacity .2s ease-out, width .4s ease;
      -webkit-appearance: none;
    }
  }
}

.icons {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  width: 2rem;
  backface-visibility: hidden;
}

.csm-icon {
  position: absolute !important;
  right: 0;
  top: 0;
  white-space: nowrap;
  display: block;
  width:100%;
  // z jakiegoś powodu 100% powoduje, że ikonka na koniec animacji się 'rusza'
  height: 99.5%;
  cursor: pointer;
  background: transparent !important;
  visibility: hidden;

  &--magnify {
    transform: rotate(-140deg);
  }

  &--close {
    transform: rotate(110deg);
  }

  &.active {
    transform: rotate(0);
    visibility: visible;
  }

  &:active:after,
  &:focus:after {
    opacity: 0 !important;
  }
}

</style>
